import {Container, Grid, Typography} from '@mui/material';
import React from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import 'pages/FormPage.css'
import sideBackgroundImage from 'assets/img.png';

const ErrorPage = (props) => {

    const navigate = useNavigate();
    const errorMessage = props.errorMessage || 'An error occurred. Please check your url.';

    return (
        <Grid container className='firstContainer'>
            <Grid item sm={12} md={6} lg={5} xl={3} className='secondContainer'>
                <Container className='thirdContainer'>
                    <Typography variant={'h4'} component={'h1'} className='audaHistory'
                                onClick={() => navigate('/login')}>
                        {errorMessage}
                    </Typography>
                    <Outlet/>
                </Container>
            </Grid>
            <Grid item sm={0} md={6} lg={7} xl={9} className='imageContainer'>
                <img src={sideBackgroundImage} alt='sideBackgroundImage' className='image'/>
            </Grid>
        </Grid>
    );

};

export default ErrorPage;
